// extracted by mini-css-extract-plugin
module.exports = {"tour-label":"_4e5f713ae4--tour-label--QLrwX"};